import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography
} from '@material-ui/core';
import { ReactNodeLike } from 'prop-types';
import React, { FC, memo, useCallback } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';

const vt = viewTexts.dialogs.createDialogTemplate;

const FormArea = styled.div`
  padding: 5px;
`;

interface Props {
  children: ReactNodeLike;
  open: boolean;
  title: string;
  descriptions: readonly string[];
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateDialogViewTemplate: FC<Props> = memo(
  ({
    children,
    open,
    onClose,
    title,
    descriptions,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => {
    const onCloseByEscape = useCallback(() => {
      onClose('');
    }, [onClose]);

    const cancelOnClick = useCallback(() => {
      onClose('cancel');
    }, [onClose]);

    const okOnClick = useCallback(() => {
      onClose('ok');
    }, [onClose]);

    return (
      <Dialog open={open} onClose={onCloseByEscape}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {descriptions.map((str, idx) => (
            <Typography key={idx}>{str}</Typography>
          ))}
          <FormArea>
            {children}
            {nonFieldErrors.map((er, i) => (
              <FormHelperText key={i} error={true}>
                {er}
              </FormHelperText>
            ))}
          </FormArea>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelOnClick} color='default'>
            {vt.cancel}
          </Button>
          <Button
            disabled={!submitButtonEnabled}
            onClick={okOnClick}
            color='primary'
            autoFocus={true}
          >
            {vt.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

CreateDialogViewTemplate.displayName = 'CreateDialogViewTemplate';
